import { render, staticRenderFns } from "./visitCustomers.vue?vue&type=template&id=f89f1ed0&scoped=true&"
import script from "./visitCustomers.vue?vue&type=script&lang=js&"
export * from "./visitCustomers.vue?vue&type=script&lang=js&"
import style0 from "./visitCustomers.vue?vue&type=style&index=0&id=f89f1ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89f1ed0",
  null
  
)

export default component.exports